// CoffeeLineQR prompt mapping for the interactive flow
const promptMapping = {
  root: {
    prompt: "Still waiting in line for coffee?",
    svg: "brewed-coffee.svg",
    options: {
      Yes: {
        prompt: "It'll be worth it! Have you already ordered?",
        svg: "coffee-cup.svg",
        options: {
          Yes: {
            prompt: "Let me guess, iced vanilla latte?",
            svg: "iced-latte.svg",
            options: {
              Yes: {
                prompt:
                  "Everyone loves a classic. I made a game for you, wanna see?",
                svg: "hot-latte.svg",
              },
              No: {
                prompt:
                  "Everyone loves a classic. I made a game for you, wanna see?",
                svg: "hot-latte.svg",
              },
              "Maybe so": {
                prompt:
                  "Alright then, keep your secrets. I made a game, wanna see?",
                svg: "sneaky.svg",
              },
            },
          },
          No: {
            prompt:
              "Ah, something unique! Just like the game I made, wanna see?",
            svg: "americano.svg",
          },
          "Maybe so": {
            prompt: "Hey, no worries. Let’s try this game I made, wanna see?",
            svg: "head-tilt.svg",
          },
        },
      },
      No: {
        prompt: "You cheeky goose, are you looking for something fun to do?",
        svg: "sneaky.svg",
        options: {
          Yes: {
            prompt: "Now you're in the right place! I made a game, wanna see?",
            svg: "brewed-coffee.svg",
          },
          No: {
            prompt: "I think you might be lost... do you need a map?",
            svg: "map-search.svg",
            options: {
              Yes: {
                prompt:
                  "I don't have a map, but I made a game for you, wanna see it?",
                svg: "head-tilt.svg",
              },
              No: {
                prompt:
                  "Well if you don't want a map, how about a game I made?",
                svg: "brewed-coffee.svg",
              },
              "Maybe so": {
                prompt: "Mystery is fun! Here’s a game I made, wanna see it?",
                svg: "sneaky.svg",
              },
            },
          },
          "Maybe so": {
            prompt:
              "Alright then, let’s see if you’re up for a game I made, wanna see?",
            svg: "head-tilt.svg",
          },
        },
      },
      "Maybe so": {
        prompt:
          "Can’t decide? That’s okay. Let’s check out a game I made, wanna see?",
        svg: "head-tilt.svg",
      },
    },
  },
  terminal: {
    prompt: "Hooray! The game is called 'Slideways'.",
    svg: "hot-latte.svg",
  },
};

export default promptMapping;
